import { isEmptyString } from '@/utils/string';
import type { AccountUser } from './entity';

/** The user's full name (first + last), or empty when neither is set. */
export function fullNameOf(user: AccountUser): string {
  return [user.first_name, user.last_name].filter((name) => !isEmptyString(name)).join(' ');
}

/** The name to show where a blank is undesirable (avatar, aria-label, delete copy): full name, else email. */
export function displayNameOf(user: AccountUser): string {
  const fullName = fullNameOf(user);
  return isEmptyString(fullName) ? user.email : fullName;
}

/** Epoch-seconds of the most recent sign-in — Ember's `lastLoginAt` (max of current/previous). */
export function lastLoginAt(user: AccountUser): number {
  return Math.max(user.last_sign_in_at ?? 0, user.current_sign_in_at ?? 0);
}

/** A user who has never signed in — their invite is still pending. */
export function isPendingInvite(user: AccountUser): boolean {
  return lastLoginAt(user) === 0;
}

/** A guest is a member homed in a different account; missing home-account data never marks a guest. */
export function isGuestOf(user: AccountUser, accountId: number): boolean {
  return user.home_account_id != null && String(user.home_account_id) !== String(accountId);
}
